import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwe6gtymas: FaireProductEntity = {
  token: "p_vwe6gtymas",
  type: "product",
  name: "Classic Recipes Of Sweden by Anna Mosesson",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/69cde16ed8358d68150a27457518cee2f1e75dc22a8c52f66890b49cbed581a2.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "[Anness Publishing]\r\n\r\n CLASSIC RECIPES OF SWEDEN\r\n \r\nTraditional food and cooking in 25 authentic dishes\r\n \r\nAnna Mosesson\r\n \r\n• Discover the delights of this distinctive Scandinavian cuisine with 25 classic recipes presented in a stylish gift book\r\n \r\n• Features mouthwatering recipes from the heart of Sweden including Toast Skagen, Sautéed Perch with Chanterelles, Braised Hare Stew with Juniper Berries, and Blueberry Pie with Clotted Cream\r\n \r\n• Chapters include Soups and Appetizers; Main Meals; Vegetables and Side Dishes; and Desserts, Cakes and Bakes\r\n \r\n• The introduction offers a fascinating overview of the Swedish landscape, festivals and key ingredients including pickled herring, regional cheeses, gravlax, cured meats, pickles, and fruit preserves\r\n \r\n• Each recipe is beautifully photographed and the instructions are easy to follow, guaranteeing success\r\n \r\n• Complete nutritional information is given for every dish\r\n \r\nTraditional Swedish cooking is hearty and based around fish",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:56.867Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
